import FontAwesomeIcon from 'Shared/FontAwesomeIcon/FontAwesomeIcon'
import NavElement from './NavElement'

const RecurrentStopped = ({ billingDay, billingEndDay, billingStartDay }) => (
  <>
    <div className="element d-flex px-4 mt-2">
      <FontAwesomeIcon className="danger mt-1 me-2" icon="circle-stop" />

      <span> Recurring invoice schedule stopped on <b>{billingEndDay}</b></span>
    </div>

    <NavElement text="Billing Start Date" value={billingStartDay} />

    <NavElement text="Billing End Date" value={billingEndDay} />

    <NavElement text="Billing Day" value={billingDay} />
  </>
)

export default RecurrentStopped
